import { AccountService } from '@abp/ng.account';
import {
  ApplicationConfiguration,
  AuthService,
  ConfigState,
  ConfigStateService,
  SetTenant,
} from '@abp/ng.core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { Select, Store } from '@ngxs/store';
import { OAuthService } from 'angular-oauth2-oidc';
import * as fs from 'file-saver';
import * as _ from 'lodash';
import { NzIconService } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable, Subject, Subscription, Observer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { dealError } from './common/error-handler';
import { COSFileUpload } from './common/file-upload';
import { MSG_TYPE } from './enum/message.enum';
import { fileSourceModel } from './model/file-source.model';
import { pathArrayModel } from './model/router-path.model';
import {
  AnnNotificationMessage,
  AnnouncementNotificationService,
} from './pages/basic-form/announcement-modal/announcement-modal.service';
import { LoginConfigurationService } from './pages/login/login-configuration.service';
import { SystemConfigurationService } from './pages/system-configuration/system-configuration.service';
import { MessagesService } from './services/messages.service';
import { ScriptLoaderService } from './services/script-loader.service';
import { SimpleReuseStrategy } from './strategy/simple-reuse-strategy';
import { TrimUtil } from './common/trimUtil';

interface RevenueMicroAppBridge {
  addDataListener(cb: (data: any) => void, autoTrigger?: boolean): void;
  removeDataListener?(cb: (data: any) => void): void;
  dispatch(data: Record<string, unknown>, nextStep?: () => void, force?: boolean): void;
}

declare global {
  interface Window {
    microApp?: RevenueMicroAppBridge;
    __MICRO_APP_ENVIRONMENT__?: boolean;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterContentChecked, AfterViewInit {
  @ViewChild('notification', { static: false }) notificationRef?: TemplateRef<{}>;
  apiUrl = environment.apis.default.url;
  uploadUrl = environment.apis.default.uploadUrl;
  tencentBucket = environment.tencentBucket.systemLogoBucket;
  tencentAppID = environment.tencentBucket.defaultAppID;
  footer = environment.footer;
  footerDiv: any = null;
  tabArray = [];
  menuArray = [];
  pathArray = pathArrayModel;
  isLogin = true;
  isInit = true;
  isIFrameInit = true;
  isJump2CustDetail = false;
  isJump2Kpi = false;
  messageType = MSG_TYPE;
  subscription = new Subscription();
  isSpinning = false;
  hiddenSiderAndHeader = false;
  selectedIndex = 0;
  isShowRightClickPlane = false; // 右键点击事件面板
  loginUserName = null;
  currentTab = null;
  currentTabIndex: number;
  currentPath = '';
  isFullScreen = false;
  isShowFooter: string | boolean = false;
  isShowTodoList = false;
  isShowInfoList = false;
  @Select(ConfigState.getOne('currentUser'))
  currentUser$: Observable<ApplicationConfiguration.CurrentUser>;

  get hasLoggedIn(): boolean {
    return this.oAuthService.hasValidAccessToken();
  }

  isCollapsed = false;
  initMenuIsCollapsed = true; // 默认菜单展开
  // defaultMenuLogoBig = 'https://businesscharge-1259078701.cos.ap-shanghai.myqcloud.com/logo/menu-logo.png';
  // defaultMenuLogoSmall = 'https://businesscharge-1259078701.cos.ap-shanghai.myqcloud.com/logo/menu-logo-small.png';
  defaultMenuLogoBig = '';
  defaultMenuLogoSmall = '';
  accessToken = null; // 用户token
  httpHeader = null; // 请求头
  tenantId = null;
  rolesList = [];
  passswordForm: FormGroup;
  isShowModal = false;
  isConfirmLoading = false;
  loginCos: any; // 声明文件上传对象
  menuBigCos: any; // 声明文件上传对象
  menuSmallCos: any; // 声明文件上传对象
  fileSourceModel = fileSourceModel;
  fileSourceType = null;
  messCount = 322;
  // todoData = {
  //   totalRows: 3,
  //   loginUrl: 'https',
  //   children: [
  //     {
  //       businessType: 1,
  //       workFlowState: 3,
  //       taskType: 1,
  //       sfth: true,
  //       stepID: 39129,
  //       taskID: 8670,
  //       custId: '25656',
  //       custCode: '176320',
  //       custName: '资阳市乐至县童家镇石板垭村民委员会',
  //       serialNum: 'REQ2021091663',
  //       processName: '乐至更名',
  //       processVersion: '1.0',
  //       ownerAccount: '4011',
  //       ownerDisplayName: '吴小花',
  //       agentAccount: '',
  //       agentDisplayName: '',
  //       createAt: '2021-09-23 16:06:31',
  //       nodeName: '营销副经理',
  //       receiveAt: '2021-09-23 16:06:31',
  //       share: 'false',
  //       formUrl: 'YNdc1&aspx=about_gm',
  //       timeoutFirstNotifyDate: '',
  //       timeoutDeadline: '',
  //       timeoutNotifyCount: 0,
  //       description: '无',
  //       optUser: 'oa:4011 aa:',
  //       optAt: '2021-09-23 16:06:31'
  //     },
  //     {
  //       businessType: 1,
  //       workFlowState: 3,
  //       taskType: 2,
  //       sfth: false,
  //       stepID: 39127,
  //       taskID: 15645,
  //       custCode: '9194957',
  //       custId: '65537',
  //       custName: '袁友军',
  //       serialNum: 'REQ2021091662',
  //       processName: '测试过户',
  //       processVersion: '1.0',
  //       ownerAccount: '4011',
  //       ownerDisplayName: '吴小花',
  //       agentAccount: '',
  //       agentDisplayName: '',
  //       createAt: '2021-09-23 16:01:15',
  //       nodeName: '营销副经理',
  //       receiveAt: '2021-09-23 16:01:15',
  //       share: 'false',
  //       formUrl: 'MoA4yC0BSKYNdc1&aspx=about_gm',
  //       timeoutFirstNotifyDate: '',
  //       timeoutDeadline: '',
  //       timeoutNotifyCount: 0,
  //       description: '无',
  //       optUser: 'oa:4011 aa:',
  //       optAt: '2021-09-23 16:01:15'
  //     },
  //     {
  //       businessType: 1,
  //       workFlowState: 3,
  //       taskType: 3,
  //       sfth: true,
  //       stepID: 39127,
  //       taskID: 15645,
  //       custCode: '9194957',
  //       custId: '65537',
  //       custName: '袁友军',
  //       serialNum: 'REQ2021091662',
  //       processName: '测试停用',
  //       processVersion: '1.0',
  //       ownerAccount: '4011',
  //       ownerDisplayName: '吴小花',
  //       agentAccount: '',
  //       agentDisplayName: '',
  //       createAt: '2021-09-23 16:01:15',
  //       nodeName: '营销副经理',
  //       receiveAt: '2021-09-23 16:01:15',
  //       share: 'false',
  //       formUrl: 'MoA4yC0BSKYNdc1&aspx=about_gm',
  //       timeoutFirstNotifyDate: '',
  //       timeoutDeadline: '',
  //       timeoutNotifyCount: 0,
  //       description: '无',
  //       optUser: 'oa:4011 aa:',
  //       optAt: '2021-09-23 16:01:15'
  //     },
  //     {
  //       businessType: 1,
  //       workFlowState: -1,
  //       taskType: 3,
  //       sfth: false,
  //       stepID: 39127,
  //       taskID: 15645,
  //       custCode: '9194957',
  //       custId: '65537',
  //       custName: '同一人',
  //       serialNum: 'REQ2021091662',
  //       processName: '测试停用1111',
  //       processVersion: '1.0',
  //       ownerAccount: '4011',
  //       ownerDisplayName: '吴小花',
  //       agentAccount: '',
  //       agentDisplayName: '',
  //       createAt: '2021-09-23 16:01:15',
  //       nodeName: '营销副经理',
  //       receiveAt: '2021-09-23 16:01:15',
  //       share: 'false',
  //       formUrl: 'MoA4yC0BSKYNdc1&aspx=about_gm',
  //       timeoutFirstNotifyDate: '',
  //       timeoutDeadline: '',
  //       timeoutNotifyCount: 0,
  //       description: '无',
  //       optUser: 'oa:4011 aa:',
  //       optAt: '2021-09-23 16:01:15'
  //     },
  //   ]
  // };
  todoData = null;
  todoListData = [];
  totalTodo = 0;
  infoListData = [];
  timer = null;
  infoTimer = null;
  isOpenTaskNotice = '';
  showDataMaskingBtn = false;
  messageConnection: any = null;
  private signalRRestartTimer: any = null;
  private isDestroyed = false;
  downloadPercent = 0;
  hotlineHasLogin = false;

  // 公告资讯
  announcements: any[] = [];
  loadingAnnouncements = false;
  isShowAnnouncementList = false; // 控制公告下拉列表显示

  private annTypeColors = {
    1: '#7085D5',
    2: '#7085D5',
    3: '#E69962',
    4: '#E69962',
    5: '#2181BA',
    6: '#2181BA',
    7: '#57A381',
  };

  private annTypeBgColors = {
    1: '#E8E7F5',
    2: '#E8E7F5',
    3: '#FBF0CC',
    4: '#FBF0CC',
    5: '#D7F2FF',
    6: '#D7F2FF',
    7: '#D6F5E3',
  };

  isPreviewModalVisible = false;
  selectedAnnouncement: any = null;
  private destroy$ = new Subject<void>();
  private readonly platformInitAuthMessageType = 'platform:revenue:init-auth';
  private readonly platformMessageType = 'platform:revenue:navigate';
  private readonly platformRefreshMessageType = 'platform:revenue:refresh-current-page';
  private readonly embedReadyMessageType = 'revenue:embed:ready';
  private readonly customerDetailRoute = '/customer_info/customer_detail';
  private readonly allowedParentOrigins = new Set([
    'http://platform.yuncloudtech.cn',
    'https://platform.yuncloudtech.cn',
    'http://localhost:4200',
  ]);
  embedMode = false;
  private embedParentOrigin = 'http://platform.yuncloudtech.cn';
  private embedMenusLoading = false;
  private pendingEmbedNavigationPath: string | null = null;
  private lastEmbedAccessToken: string | null = null;
  private lastHandledLoginQueryKey = '';
  private embeddedLoginInitialized = false;
  private embeddedSessionBootstrapStarted = false;

  private annSubscription: Subscription;
  isShowMenu = true;
  constructor(
    private fb: FormBuilder,
    public accountService: AccountService,
    private oAuthService: OAuthService,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public messagesService: MessagesService,
    private iconService: NzIconService,
    public dataService: SystemConfigurationService,
    public loginService: LoginConfigurationService,
    private message: NzMessageService,
    private store: Store,
    private el: ElementRef,
    private modal: NzModalService,
    protected httpClient: HttpClient,
    private config: ConfigStateService,
    private sanitizer: DomSanitizer,
    public notificationService: NzNotificationService,
    private titleService: Title,
    private systemService: SystemConfigurationService,
    private annNotiService: AnnouncementNotificationService,
    private scriptLoader: ScriptLoaderService
  ) {
    this.iconService.fetchFromIconfont({
      scriptUrl: 'assets/iconfont.js',
    });
  }

  // ==================== 生命周期钩子 ====================

  buildPasswordForm() {
    this.passswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, this.notSameAsOldValidator]],
      checkPassword: ['', [Validators.required], [this.confirmationValidator]],
    });
    this.passswordForm.get('newPassword').valueChanges.subscribe(() => {
      this.passswordForm.get('checkPassword').updateValueAndValidity();
    });
    this.passswordForm.get('oldPassword').valueChanges.subscribe(() => {
      this.passswordForm.get('newPassword').updateValueAndValidity();
    });
  }

  confirmationValidator = (control: FormControl) =>
    new Observable((observer: Observer<ValidationErrors | null>) => {
      setTimeout(() => {
        if (!control.value) {
          observer.next({ error: true, required: true });
        } else if (control.value !== this.passswordForm.controls.newPassword.value) {
          observer.next({ error: true, confirm: true });
        } else {
          observer.next(null);
        }
        observer.complete();
      }, 10);
    });

  notSameAsOldValidator = (control: FormControl): ValidationErrors | null => {
    const old = this.passswordForm?.get('oldPassword')?.value;
    if (control.value && old && control.value === old) {
      return { sameAsOld: true };
    }
    return null;
  }

  savePassword() {
    this.isConfirmLoading = true;
    this.dataService.changePassword(TrimUtil.trimObject(this.passswordForm.value)).subscribe(
      (data) => {
        this.passswordForm.reset();
        this.isSpinning = false;
        this.isConfirmLoading = false;
        this.message.create('success', '密码修改成功');
        this.isShowModal = false;
        setTimeout(() => {
          this.authService.logout().subscribe(() => {
            this.router.navigate(['/login']);
          });
        }, 500);
      },
      (error) => {
        this.isConfirmLoading = false;
        this.message.create('error', error.error?.error?.message);
      }
    );
  }

  // @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
  //   // event.preventDefault();
  //   event.returnValue = true;
  //   return '确认关闭页面？';
  // }

  ngOnInit() {
    const url = new URL(window.location.href);
    const inIframe = window.self !== window.top;
    const inMicroApp = !!window['__REVENUE_MICRO_APP_EMBED__'] || !!window.__MICRO_APP_ENVIRONMENT__ || !!window.microApp;
    const embedParam = this.getCurrentQueryParam(url, 'embed').toLowerCase();
    const hideMenuByUrl = embedParam === '1' || embedParam === 'true';
    this.embedMode = inIframe || hideMenuByUrl || inMicroApp;
    this.isShowMenu = !this.embedMode;
    if (this.embedMode) {
      this.embedParentOrigin = this.resolveEmbedParentOrigin();
      this.hiddenSiderAndHeader = true;
    }

    this.buildPasswordForm();
    window.addEventListener('message', this.handleWindowMessage);
    window.microApp?.addDataListener(this.handleMicroAppData, true);

    this.hotlineHasLogin = false;
    this.initGlobalClipboardTrim();
    this.getTenantId();
    this.initTrigger();
    if (this.embedMode && this.hasLoggedIn) {
      this.ensureEmbedMenusLoaded();
    }

    const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = '../../../assets/images/' + environment.favicon;
    document.getElementsByTagName('head')[0].appendChild(link);
    // tslint:disable-next-line:no-unused-expression
    localStorage.getItem('tabArrString') &&
      (this.tabArray = JSON.parse(localStorage.getItem('tabArrString')));
    this.tabArray = _.uniqBy(this.tabArray, 'name');
    localStorage.setItem('tabArrString', JSON.stringify(this.tabArray));
    // tslint:disable-next-line:no-unused-expression
    localStorage.getItem('menus') && (this.menuArray = JSON.parse(localStorage.getItem('menus')));
    this.currentPath = '';
    this.subscribeMessage();
    if (!this.embedMode) {
      this.hiddenSiderAndHeader = false;
    }
    if (this.embedMode) {
      setTimeout(() => this.notifyParentEmbedReady(this.router.url), 0);
    }
    this.subscription.add(
      this.activatedRoute.queryParams.subscribe((queryParams) => {
        this.handleRouteQueryParams(queryParams);
      })
    );
    this.subscription.add(this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.embedMode) {
          // console.log('[RevenueEmbed][Child] route result', {
          //   url: event.url,
          //   urlAfterRedirects: event.urlAfterRedirects,
          //   pendingPath: this.pendingEmbedNavigationPath,
          // });
        }
        this.notifyParentEmbedReady(event.urlAfterRedirects || event.url);
        // 当导航成功结束时执行
        this.newTab(
          _.find(this.pathArray, (obj) => {
            const currentUrl = _.split(event.url, '?');
            return obj.path === currentUrl[0];
          })
        );
        // 解决首页刷新后标签页关闭问题
        this.tabArray = _.uniqBy(this.tabArray, 'name');
        localStorage.setItem('tabArrString', JSON.stringify(this.tabArray));
        this.currentPath = event.url;
        if (
          (event.url === '/login' ||
            event.url.indexOf('/login/login_loading') !== -1 ||
            event.url === '/') &&
          this.hasLoggedIn
        ) {
          this.isLogin = false;
          this.bootstrapAuthenticatedShell();
          // this.getCustomerFile();
          // this.infoTimer = setInterval(() => {
          //   this.getCustomerFile();
          // }, 300000);
          // console.log('/basic_form/basic_form');
          const defaultRoute = this.getDefaultEmbedRoute();
          if (defaultRoute) {
            this.router.navigate(
              [defaultRoute]
              // ,{state: {redirectUrl: this.router.url}}
            );
            this.newTab(_.find(this.pathArray, (obj) => obj.path === defaultRoute));
          }
        } else if (
          event.url !== '/login' &&
          event.url.indexOf('/login/login_loading') === -1 &&
          event.url !== '/' &&
          !this.hasLoggedIn
        ) {
          this.isLogin = true;
          // this.router.navigate(['/welcome']
          //   // ,{state: {redirectUrl: this.router.url}}
          //   );
          this.tabArray = [];
        } else if (
          event.url !== '/login' &&
          event.url.indexOf('/login/login_loading') === -1 &&
          event.url !== '/' &&
          this.hasLoggedIn
        ) {
          this.isLogin = false;
          if (!this.loginUserName) {
            this.bootstrapAuthenticatedShell();
            // this.getCustomerFile();
            // this.infoTimer = setInterval(() => {
            //   this.getCustomerFile();
            // }, 300000);
          }
          if (event.url.indexOf('/customer_info/customer_info') !== -1) {
            this.messagesService.sendMessage({ name: this.messageType.HANDLE_CUST_INFO_SCROLL });
          }
          // this.getUserTitle();
          // this.loginUserName = sessionStorage.getItem('loginUserName');
        } else if (
          (event.url === '/login' ||
            event.url.indexOf('/login/login_loading') !== -1 ||
            event.url === '/') &&
          !this.hasLoggedIn
        ) {
          // localStorage.removeItem('tabArrString');
          // this.tabArray = [];
          // if (event.url === '/') {
          //   this.router.navigate(['/welcome']);
          // }
          this.isLogin = true;
        }

        this.navigateToPendingEmbedPathIfNeeded();
        // if (this.hasLoggedIn) {
        //   this.oAuthService.refreshToken().then(r => {
        //     console.log('refreshToken：', r);
        //   });
        // }
      }
    }));
    document.body.addEventListener('click', (e) => {
      // e.stopPropagation();
      // e.preventDefault();
      this.isShowRightClickPlane = false;
      this.isShowTodoList = false;
      this.isShowInfoList = false;
      this.isShowAnnouncementList = false;
    });

    this.annSubscription = this.annNotiService.notification$.subscribe(
      (notification: AnnNotificationMessage) => {
        if (notification.action === 'read') {
          this.announcements = this.announcements.filter(
            (item) => item.id !== notification.meta.id
          );
        } else if (notification.action === 'reload') {
          this.loadPopupAnnouncements();
        }
      }
    );
  }

  private handleRouteQueryParams(queryParams: any): void {
    const targetPath = this.normalizeEmbedUrl(queryParams?.targetPath);
    if (targetPath) {
      this.pendingEmbedNavigationPath = targetPath;
    }

    if (queryParams.isKpi || queryParams.isCustDetail || this.hiddenSiderAndHeader) {
      // console.log(queryParams);
      // this.handleOnlyContent();
      this.hiddenSiderAndHeader = true;
      this.triggerWidth(this.isCollapsed);
    }

    if (!queryParams.token && !queryParams.ticket) {
      this.lastHandledLoginQueryKey = '';
      return;
    }

    const loginQueryKey = [
      queryParams.token || queryParams.ticket || '',
      queryParams.systemsource || '',
      queryParams.targetPath || '',
      queryParams.isKpi || '',
      queryParams.isCustDetail || '',
      queryParams.custId || '',
    ].join('|');
    if (loginQueryKey === this.lastHandledLoginQueryKey) {
      return;
    }
    this.lastHandledLoginQueryKey = loginQueryKey;

    const params = {
      clientId: 'BizChargeSystem_App',
      token: queryParams.token || queryParams.ticket,
      ...(queryParams.systemsource ? { systemSource: queryParams.systemsource } : {}),
    };
    this.isSpinning = true;
    if (this.hotlineHasLogin) {
      // console.log('跳转到详情页');
      this.doJumpLogin(queryParams);
      return;
    }

    this.dataService.loginByToken(params).subscribe(
      (data) => {
        if (data) {
          this.applyEmbeddedAccessToken({
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
            expiresIn: data.expires_in,
            scope: data.scope,
            tokenType: data.token_type,
          });
          this.doJumpLogin(queryParams);
        }
      },
      (error) => {
        this.lastHandledLoginQueryKey = '';
        this.isSpinning = false;
      }
    );
  }

  doJumpLogin(queryParams) {
    this.config.dispatchGetAppConfiguration().subscribe(
      () => {
        // this.message.create('success', `登录成功`);
        // todo test jump to kpi
        const targetPath = this.normalizeEmbedUrl(queryParams?.targetPath);
        if (queryParams.isKpi) {
          this.hiddenSiderAndHeader = true;
          this.isJump2Kpi = true;
          this.router
            .navigate(['/search/business_indicators'], { queryParams: { isKpi: true } })
            .then((res) => {
              this.isSpinning = false;
              if (this.el.nativeElement.querySelector('.main-content')) {
                this.triggerWidth();
              }
              this.getTenantId();
            });
        } else if (queryParams.isCustDetail) {
          this.hiddenSiderAndHeader = true;
          this.isJump2CustDetail = true;
          // console.log('id: ', queryParams.custId);
          localStorage.setItem('currentCust', JSON.stringify({ id: queryParams.custId }));
          // console.log('events');
          this.router
            .navigate(['/customer_info/customer_detail'], {
              queryParams: { isCustDetail: true, custId: queryParams.custId },
            })
            .then((res) => {
              this.isSpinning = false;
              if (this.el.nativeElement.querySelector('.main-content')) {
                this.triggerWidth();
              }
              this.getTenantId();
            });
          // const datas = {
          //   id: queryParams.custId,
          // };
          // localStorage.removeItem('currentCust');
          // this.messagesService.sendMessage({name: this.messageType.SHOW_CUSTOMER_DETAIL, value: datas});
        } else if (targetPath) {
          this.pendingEmbedNavigationPath = targetPath;
          this.ensureEmbedMenusLoaded();
          this.navigateToPendingEmbedPathIfNeeded();
        } else {
          this.router.navigate(['/basic_form/basic_form']).then((res) => {
            this.doGetMenus();
          });
        }
      },
      (error) => {
        this.isSpinning = false;
        this.message.create(
          'error',
          `获取权限失败，请重新登录。${error.error?.error?.message || ''}`
        );
      }
    );
  }

  doGetMenus() {
    this.messagesService.sendMessage({ name: this.messageType.START_GET_MENUS });
    this.loginService.getUserMenus().subscribe(
      (value) => {
        if (value.items) {
          localStorage.setItem('menus', JSON.stringify(value.items));
          this.messagesService.sendMessage({
            name: this.messageType.HAS_LOGIN,
          });
        }
      },
      (error) => {
        this.isSpinning = false;
        this.message.error(dealError(`菜单获取失败，请重新登录。`, error));
      }
    );
  }

  handleOnlyContent() {
    this.hiddenSiderAndHeader = true;
    document.getElementById('main-content').style.width = '100%';
    document.getElementById('main-content').style.height = '100%';
    document.getElementById('main-content').style.top = '0';
    if (this.isJump2CustDetail) {
      this.router.navigate(['/customer_info/customer_detail'], {
        queryParams: { isCustDetail: true },
      });
    } else if (this.isJump2Kpi) {
      this.router.navigate(['/search/business_indicators'], { queryParams: { isKpi: true } });
    }
  }

  createFooter() {
    this.footerDiv = document.createElement('div');
    this.footerDiv.innerHTML = this.footer;
    const body = this.el.nativeElement.querySelector('.footer-content');
    body.appendChild(this.footerDiv);
  }

  initSignalR() {
    if (this.embedMode || this.messageConnection) {
      return;
    }

    const signalRUrl = `${environment.apis.default.url}/signalr-hubs/notification`;
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(signalRUrl, { accessTokenFactory: () => localStorage.getItem('access_token') })
      // .configureLogging(signalR.LogLevel.Information)
      .build();

    const start = async () => {
      if (this.isDestroyed || this.embedMode) {
        return;
      }
      try {
        await connection.start();
      } catch (err) {
        this.signalRRestartTimer = setTimeout(start, 5000);
      }
    };

    connection.onclose(async () => {
      if (!this.isDestroyed) {
        await start();
      }
    });

    connection.on('ReceiveMessage', (message) => {
      this.handleSignalRMessage(message);
    });

    // Start the connection.
    start();

    this.messageConnection = connection;
  }

  handleSignalRMessage(message) {
    switch (message.messageType) {
      case 'MESSAGE_NEW_FLOW':
        this.getTodo();
        break;
      case 'MESSAGE_NEW_FILE':
        // this.getCustomerFile(true);
        this.downLoadExcel({ id: message.data?.exportJobId });
        break;
      case 'MESSAGE_PROGRESS_FILE':
        this.processDownloadPercent(message);
        break;
    }
  }

  sendMessage() {
    const user = 'admin';
    const message = '一条消息';
    this.messageConnection.invoke('SendMessage', user, message).catch(function (err) {
      return console.error(err.toString());
    });
  }

  ngAfterViewInit() {}

  ngAfterContentChecked() {
    if (
      this.hasLoggedIn &&
      !this.isLogin &&
      this.isInit &&
      this.el.nativeElement.querySelector('.footer-content')
    ) {
      this.triggerWidth();
      this.initSignalR();
      this.isInit = false;
      this.createFooter();
    }
    if (this.hiddenSiderAndHeader && this.isIFrameInit && document.getElementById('main-content')) {
      this.handleOnlyContent();
      this.isIFrameInit = false;
    }
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    clearTimeout(this.signalRRestartTimer);
    this.messageConnection?.stop?.();
    clearInterval(this.timer);
    clearInterval(this.infoTimer);
    this.subscription.unsubscribe();
    this.annSubscription?.unsubscribe();
    window.removeEventListener('message', this.handleWindowMessage);
    window.microApp?.removeDataListener?.(this.handleMicroAppData);
  }

  private readonly handleMicroAppData = (data: any): void => {
    const messageType = data?.type;
    if (!this.embedMode || !messageType) {
      return;
    }

    if (messageType === this.platformInitAuthMessageType || data?.auth) {
      // console.log('[RevenueMicroApp][Child] data received', {
      //   type: messageType,
      //   hasAccessToken: !!data?.auth?.accessToken,
      // });
      const tokenChanged = this.applyEmbeddedAccessToken(data?.auth);
      if (tokenChanged || this.shouldBootstrapEmbeddedLogin()) {
        this.completeEmbeddedLogin();
      }
    }

    if (messageType === this.platformRefreshMessageType) {
      if (this.isEmbeddedBootstrapRoute()) {
        return;
      }
      // console.log('[RevenueMicroApp][Child] data received', {
      //   type: messageType,
      //   currentUrl: this.router.url,
      // });
      this.refresh();
      return;
    }

    if (messageType !== this.platformMessageType) {
      return;
    }

    const targetPath = this.normalizeEmbedUrl(data.path);
    // console.log('[RevenueMicroApp][Child] data received', {
    //   type: messageType,
    //   targetPath,
    //   currentUrl: this.router.url,
    //   hasMenus: this.hasLoadedEmbedMenus(),
    // });
    if (!targetPath) {
      return;
    }

    this.pendingEmbedNavigationPath = targetPath;
    this.navigateToPendingEmbedPathIfNeeded();
  };

  private readonly handleWindowMessage = (event: MessageEvent) => {
    const messageType = event.data?.type;
    if (!messageType) {
      return;
    }

    if (messageType === 'hotlineTokenInfo') {
      this.applyEmbeddedAccessToken({
        accessToken: event.data.hotlineAccessToken,
        refreshToken: event.data.hotlineRefreshToken,
        expiresIn: event.data.hotlineExpiresIn,
        scope: event.data.hotlineScope,
        tokenType: event.data.hotlineTokenType,
      });
      this.hotlineHasLogin = true;
      return;
    }

    if (!this.embedMode || !this.isAllowedParentOrigin(event.origin)) {
      return;
    }

    if (messageType === this.platformInitAuthMessageType) {
      // console.log('[RevenueEmbed][Child] message received', {
      //   type: messageType,
      //   origin: event.origin,
      //   hasAccessToken: !!event.data?.auth?.accessToken,
      // });
      const tokenChanged = this.applyEmbeddedAccessToken(event.data?.auth);
      if (tokenChanged || this.shouldBootstrapEmbeddedLogin()) {
        this.completeEmbeddedLogin();
      }
      return;
    }

    if (messageType === this.platformRefreshMessageType) {
      if (this.isEmbeddedBootstrapRoute()) {
        return;
      }
      // console.log('[RevenueEmbed][Child] message received', {
      //   type: messageType,
      //   origin: event.origin,
      //   currentUrl: this.router.url,
      // });
      this.refresh();
      return;
    }

    if (messageType !== this.platformMessageType) {
      return;
    }

    const targetPath = this.normalizeEmbedUrl(event.data.path);
    // console.log('[RevenueEmbed][Child] message received', {
    //   type: messageType,
    //   origin: event.origin,
    //   targetPath,
    //   currentUrl: this.router.url,
    //   hasMenus: this.hasLoadedEmbedMenus(),
    // });
    if (!targetPath) {
      return;
    }

    this.pendingEmbedNavigationPath = targetPath;
    this.navigateToPendingEmbedPathIfNeeded();
  };

  private notifyParentEmbedReady(currentPath?: string): void {
    if (!this.embedMode) {
      return;
    }

    const normalizedPath = this.normalizeEmbedUrl(currentPath || this.router.url);
    const payload = {
      type: this.embedReadyMessageType,
      currentPath: normalizedPath || this.router.url.split('?')[0],
    };

    window.microApp?.dispatch(payload, undefined, true);

    if (!window.parent || window.parent === window) {
      return;
    }

    window.parent.postMessage(
      payload,
      this.embedParentOrigin
    );
  }

  private isAllowedParentOrigin(origin: string): boolean {
    if (!origin) {
      return false;
    }

    if (this.allowedParentOrigins.has(origin)) {
      this.embedParentOrigin = origin;
      return true;
    }

    if (origin === this.embedParentOrigin) {
      return true;
    }

    if (/^https?:\/\/([^.]+\.)?yuncloudtech\.cn(?::\d+)?$/i.test(origin)) {
      this.embedParentOrigin = origin;
      return true;
    }

    return false;
  }

  private normalizeEmbedUrl(path: string): string {
    let value = String(path || '').trim();
    if (!value) {
      return '';
    }

    try {
      const parsed = new URL(value, window.location.origin);
      value = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      // Keep the original relative value.
    }

    const hashIndex = value.indexOf('#');
    if (hashIndex !== -1) {
      const hashValue = value.slice(hashIndex + 1);
      if (hashValue.startsWith('/')) {
        return this.normalizeEmbedUrl(hashValue);
      }
      value = value.slice(0, hashIndex);
    }

    return value.startsWith('/') ? value : `/${value}`;
  }

  private normalizeEmbedComparableUrl(path: string): string {
    const normalized = this.normalizeEmbedUrl(path);
    if (!normalized) {
      return '';
    }

    const routePath = normalized.split('?')[0];
    if (routePath === this.customerDetailRoute) {
      const custId = this.getEmbedQueryParam(normalized, 'custId');
      return custId ? `${this.customerDetailRoute}?custId=${custId}` : this.customerDetailRoute;
    }

    return normalized;
  }

  private getEmbedQueryParam(path: string, key: string): string {
    const query = path.split('?')[1] || '';
    if (!query) {
      return '';
    }

    return new URLSearchParams(query).get(key)?.trim() || '';
  }

  private getCurrentQueryParam(url: URL, key: string): string {
    const value = url.searchParams.get(key);
    if (value) {
      return value.trim();
    }

    const hashQueryIndex = url.hash.indexOf('?');
    if (hashQueryIndex === -1) {
      return '';
    }

    return new URLSearchParams(url.hash.slice(hashQueryIndex + 1)).get(key)?.trim() || '';
  }

  private getDefaultEmbedRoute(): string | null {
    if (this.embedMode) {
      return this.pendingEmbedNavigationPath;
    }

    return '/basic_form/basic_form';
  }

  private hasLoadedEmbedMenus(): boolean {
    if (this.embedMode) {
      return true;
    }

    try {
      const menus = JSON.parse(localStorage.getItem('menus'));
      return Array.isArray(menus) && menus.length > 0;
    } catch {
      return false;
    }
  }

  private ensureEmbedMenusLoaded(): void {
    this.flushPendingEmbedNavigation();
  }

  private flushPendingEmbedNavigation(): void {
    if (!this.pendingEmbedNavigationPath || !this.hasLoadedEmbedMenus()) {
      return;
    }

    const targetPath = this.pendingEmbedNavigationPath;
    this.pendingEmbedNavigationPath = null;
    const currentPath = this.normalizeEmbedUrl(this.router.url);
    if (this.normalizeEmbedComparableUrl(targetPath) !== this.normalizeEmbedComparableUrl(currentPath)) {
      this.router.navigateByUrl(targetPath);
    }
  }

  private navigateToPendingEmbedPathIfNeeded(): void {
    if (!this.embedMode || !this.pendingEmbedNavigationPath) {
      return;
    }

    if (!this.hasLoadedEmbedMenus()) {
      this.ensureEmbedMenusLoaded();
      return;
    }

    const currentPath = this.normalizeEmbedUrl(this.router.url);
    if (
      this.normalizeEmbedComparableUrl(currentPath) ===
      this.normalizeEmbedComparableUrl(this.pendingEmbedNavigationPath)
    ) {
      // console.log('[RevenueEmbed][Child] navigate skipped', {
      //   reason: 'already-on-target',
      //   currentPath,
      // });
      this.pendingEmbedNavigationPath = null;
      return;
    }

    const targetPath = this.pendingEmbedNavigationPath;
    // console.log('[RevenueEmbed][Child] navigate start', {
    //   targetPath,
    //   currentPath,
    // });
    this.router.navigateByUrl(targetPath).then((success) => {
      // console.log('[RevenueEmbed][Child] navigate finish', {
      //   targetPath,
      //   success,
      //   finalUrl: this.router.url,
      // });
      if (
        success &&
        this.normalizeEmbedComparableUrl(this.router.url) ===
          this.normalizeEmbedComparableUrl(targetPath)
      ) {
        this.pendingEmbedNavigationPath = null;
      }
    });
  }

  private resolveEmbedParentOrigin(): string {
    try {
      const referrer = document.referrer || '';
      if (referrer) {
        return new URL(referrer).origin;
      }
    } catch {
      // Fallback to the configured platform origin below.
    }

    return this.embedParentOrigin;
  }

  private applyEmbeddedAccessToken(auth: any): boolean {
    const accessToken = String(auth?.accessToken ?? auth?.access_token ?? '').trim();
    if (!accessToken) {
      return false;
    }

    if (this.lastEmbedAccessToken === accessToken && this.hasLoggedIn) {
      return false;
    }

    const refreshToken = String(auth?.refreshToken ?? auth?.refresh_token ?? '').trim();
    const tokenType = String(auth?.tokenType ?? auth?.token_type ?? 'Bearer').trim() || 'Bearer';
    const scope = String(auth?.scope ?? '').trim();
    const expiresInValue = Number(auth?.expiresIn ?? auth?.expires_in);
    const expiresIn = Number.isFinite(expiresInValue) && expiresInValue > 0 ? expiresInValue : null;

    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('token_type', tokenType);

    if (refreshToken) {
      localStorage.setItem('refresh_token', refreshToken);
    } else {
      localStorage.removeItem('refresh_token');
    }

    if (scope) {
      localStorage.setItem('granted_scopes', scope);
    } else {
      localStorage.removeItem('granted_scopes');
    }

    if (expiresIn) {
      localStorage.setItem('expires_in', String(expiresIn));
      localStorage.setItem('expires_at', String(Date.now() + expiresIn * 1000));
    } else {
      localStorage.removeItem('expires_in');
      localStorage.removeItem('expires_at');
    }

    this.lastEmbedAccessToken = accessToken;
    this.embeddedSessionBootstrapStarted = false;
    return true;
  }

  private bootstrapAuthenticatedShell(): void {
    if (this.embedMode && this.embeddedSessionBootstrapStarted) {
      return;
    }

    if (this.embedMode) {
      this.embeddedSessionBootstrapStarted = true;
    }

    this.getSystemSetting();
    this.getUserTitle();
    this.getUserSystemInfo();
  }

  private completeEmbeddedLogin(): void {
    this.embeddedLoginInitialized = true;
    this.isLogin = false;
    this.bootstrapAuthenticatedShell();
    this.getTenantId();

    const currentPath = this.router.url.split('?')[0];
    if (
      currentPath === '/login' ||
      currentPath === '/' ||
      currentPath.indexOf('/login/login_loading') !== -1
    ) {
      if (!this.pendingEmbedNavigationPath && !this.embedMode) {
        this.pendingEmbedNavigationPath = this.getDefaultEmbedRoute();
      }
    }

    this.ensureEmbedMenusLoaded();
    this.navigateToPendingEmbedPathIfNeeded();
  }

  private shouldBootstrapEmbeddedLogin(): boolean {
    if (!this.embedMode) {
      return false;
    }

    if (!this.embeddedLoginInitialized) {
      return true;
    }

    return this.isEmbeddedBootstrapRoute() && !this.hasLoadedEmbedMenus();
  }

  private isEmbeddedBootstrapRoute(): boolean {
    const currentPath = this.router.url.split('?')[0];
    return (
      currentPath === '/login' ||
      currentPath === '/' ||
      currentPath.indexOf('/login/login_loading') !== -1
    );
  }

  // ==================== 业务方法 ====================

  subscribeMessage() {
    this.subscription.add(
      this.messagesService.getMessage().subscribe((msg) => {
        if (msg.name === this.messageType.HAS_LOGIN) {
          // tslint:disable-next-line:no-unused-expression
          localStorage.getItem('menus') &&
            (this.menuArray = JSON.parse(localStorage.getItem('menus')));
          this.isSpinning = false;
          if (this.el.nativeElement.querySelector('.main-content')) {
            this.triggerWidth();
          }
          this.getTenantId();
        }
        if (msg.name === this.messageType.START_GET_MENUS) {
          this.isSpinning = true;
        }
        if (msg.name === this.messageType.REFRESH_MENU_IMG_BIG) {
          this.defaultMenuLogoBig = localStorage.getItem('menuLogoBig')
            ? localStorage.getItem('menuLogoBig')
            : '../../../assets/images/' + environment.loginLogo;
        }
        if (msg.name === this.messageType.REFRESH_MENU_IMG_SMALL) {
          this.defaultMenuLogoSmall = localStorage.getItem('menuLogoSmall')
            ? localStorage.getItem('menuLogoSmall')
            : '../../../assets/images/' + environment.loginLogo;
        }
        if (msg.name === this.messageType.REFRESH_LOGIN_TITLE) {
          if (msg.isShowCopyright !== null) {
            this.isShowFooter = msg.isShowCopyright === 0;
          } else {
            this.isShowFooter = true;
          }
        }
        if (msg.name === this.messageType.NEW_ARTICLES) {
          this.tabArray = JSON.parse(localStorage.getItem('tabArrString'));
          let tab = {};
          for (const item of this.tabArray) {
            if (item.name === '添加文章') {
              tab = item;
            }
          }
          this.closeTab(tab);
          this.router.navigate(['/we_chat/article_search']);
          this.messagesService.sendMessage({ name: this.messageType.LIST_ARTICLE });
        }
        if (msg.name === this.messageType.START_EXPORT_FILE) {
          // this.message.remove();
          // sessionStorage.setItem('loadingMessageId', this.message.loading(`导出数据中...${this.downloadPercent}%`, {nzDuration: 0, nzAnimate: false}).messageId);
          this.downloadPercent = 0;
          this.notificationService.remove();
          this.notificationService.template(this.notificationRef, {
            nzDuration: 0,
            nzAnimate: false,
          });
        }
        if (msg.name === this.messageType.EXPORT_FILE_ERROR) {
          this.notificationService.remove();
        }
      })
    );
  }

  setHeader = () => {
    this.accessToken = localStorage.getItem('access_token');
    this.httpHeader = 'Bearer ' + this.accessToken;
    return { Authorization: this.httpHeader };
  };

  // 加载弹窗公告
  loadPopupAnnouncements(): void {
    this.loadingAnnouncements = true;
    this.systemService.getPopupAnnouncements().subscribe(
      (res: any) => {
        if (res && Array.isArray(res.items)) {
          // 假设API返回 { items: [...] }
          this.announcements = res.items;

          if (this.announcements.length > 0) {
            this.isShowAnnouncementList = true;
          }
        } else {
          console.error('获取弹窗公告失败:', res);
          this.announcements = [];
        }
        this.loadingAnnouncements = false;
      },
      (error) => {
        console.error('获取弹窗公告API请求失败:', error);
        this.announcements = [];
        this.loadingAnnouncements = false;
      }
    );
  }

  // 跳转到公告详情页
  goToAnnouncementDetail(announcement: any): void {
    this.selectedAnnouncement = { ...announcement, content: '' }; // 使用扩展运算符创建副本
    this.isPreviewModalVisible = true; // 先打开模态框，显示Loading状态

    this.systemService
      .getAnnouncementDetail(announcement.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (detailRes: any) => {
          if (detailRes) {
            // 更新 selectedAnnouncement 的 content
            this.selectedAnnouncement.content = detailRes.content;
          } else {
            this.selectedAnnouncement.content = 'Failed to load content.';
            console.error('获取公告详情失败:', detailRes);
          }
        },
        (error) => {
          this.selectedAnnouncement.content = 'Error loading content.';
          console.error('获取公告详情API请求失败:', error);
        }
      );
  }

  // 关闭公告预览模态框
  handlePreviewCancel(): void {
    this.isPreviewModalVisible = false;
    this.selectedAnnouncement = null; // 清空选中的公告

    setTimeout(() => {
      if (this.announcements.length > 0) {
        this.isShowAnnouncementList = true;
      }
    }, 300);
  }

  // 获取公告类型颜色 (从 BasicFormComponent 复制过来)
  getAnnTypeColor(annType: string | number): string {
    return this.annTypeColors[annType.toString()] || '#ccc'; // 如果未定义，则返回默认灰色
  }

  getAnnTypeBgColor(annType: string | number): string {
    return this.annTypeBgColors[annType.toString()] || '#ccc'; // 如果未定义，则返回默认灰色
  }

  // 显示/隐藏公告列表
  showAnnouncementList($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

    this.isShowAnnouncementList = !this.isShowAnnouncementList;
    this.isShowTodoList = false; // 关闭待办事项列表
    this.isShowInfoList = false; // 关闭消息中心列表
    this.isShowRightClickPlane = false; // 关闭右键菜单
  }

  getTodo() {
    this.dataService.getTodoData().subscribe(
      (data) => {
        this.todoData = data;
        this.totalTodo = data.totalRows;
        if (data.children) {
          // this.todoListData = _.filter(data.children, item => item.workFlowState !== -2);
          this.todoListData = [...data.children];
        }
      },
      (error) => {
        clearInterval(this.timer);
        this.message.create('error', dealError(`获取待办任务信息`, error));
      }
    );
  }

  getCustomerFile(isDownload = false) {
    this.dataService.getTopFile().subscribe(
      (data) => {
        this.infoListData = [...data.items];
        if (isDownload && data.items && data.items.length > 0) {
          this.downLoadExcel(data.items[0]);
        }
      },
      (error) => {
        clearInterval(this.infoTimer);
        this.message.create('error', dealError(`获取信息`, error));
      }
    );
  }

  processDownloadPercent(message) {
    this.downloadPercent =
      _.ceil((message.data?.pageIndex / message.data?.pageCount) * 100, 2) || 0;
    // this.message.remove();
    // sessionStorage.setItem('loadingMessageId', this.message.loading(`导出数据中...${this.downloadPercent}%`, {nzDuration: 0, nzAnimate: false}).messageId);
    // this.notificationService.remove();
    // this.notificationService.template(this.notificationRef, {nzDuration: 0, nzAnimate: false});
  }

  getPageSettingData(tenantId) {
    this.isSpinning = true;
    this.dataService.getPageSettingByTenantId(tenantId).subscribe(
      (data) => {
        this.isSpinning = false;
        if (data) {
          this.isShowFooter = data.isShowCopyright === 0;
          this.fileSourceType = data.fileSourceType;
          localStorage.setItem('twoFactorAuthCode', data.twoFactorAuthCode);
          this.processImgDownload(data);

          // if (this.fileSourceType === 0) {
          //   // 不启用采集上传功能
          //   // 从本地存储取数据，如果没有，则显示默认数据
          //   this.messagesService.sendMessage({
          //     name: this.messageType.REFRESH_LOGIN_TITLE,
          //     loginTitle: data.loginTitle,
          //     loginPic: localStorage.getItem('loginIcon'),
          //     isShowCopyright: data.isShowCopyright
          //   });
          //   this.defaultMenuLogoBig = localStorage.getItem('menuLogoBig') ? localStorage.getItem('menuLogoBig') : '../../../assets/images/login-logo.png';
          //   this.defaultMenuLogoSmall = localStorage.getItem('menuLogoSmall') ? localStorage.getItem('menuLogoSmall') : '../assets/images/index/menu-logo-small.png';
          // } else if (this.fileSourceType === 1) {
          //   // 本地存储
          //   if (this.router.url === '/login' || this.router.url === '/') {
          //     if (this.hasLoggedIn) {
          //       this.downloadImgByPath(data);
          //     } else {
          //       if (data.loginIconPath) {
          //         this.downLoadImgUnauthorized(data);
          //         this.messagesService.sendMessage({
          //           name: this.messageType.REFRESH_LOGIN_TITLE,
          //           isShowCopyright: data.isShowCopyright,
          //           loginTitle: data.loginTitle
          //         });
          //       } else {
          //         this.messagesService.sendMessage({
          //           name: this.messageType.REFRESH_LOGIN_TITLE,
          //           isShowCopyright: data.isShowCopyright,
          //           loginTitle: data.loginTitle,
          //           loginPic: null
          //         });
          //       }
          //     }
          //   } else {
          //     localStorage.setItem('loginTitle', data.loginTitle);
          //     localStorage.setItem('loginFooter', String(data.isShowCopyright));
          //     this.downloadImgByPath(data);
          //   }
          // } else if (this.fileSourceType === 2) {
          //   localStorage.setItem('loginTitle', data.loginTitle);
          //   // 腾讯云上传功能
          //   this.setImageUrl(data);
          // } else if (this.fileSourceType === 3) {
          //   // 阿里云上传
          // } else {
          //   this.defaultMenuLogoBig = localStorage.getItem('menuLogoBig') ? localStorage.getItem('menuLogoBig') : '../../../assets/images/login-logo.png';
          //   this.defaultMenuLogoSmall = localStorage.getItem('menuLogoSmall') ? localStorage.getItem('menuLogoSmall') : '../assets/images/index/menu-logo-small.png';
          // }
        }
      },
      (error) => {
        this.isSpinning = false;
        this.message.create('error', dealError(`获取信息`, error));
      }
    );
  }

  processImgDownload(data) {
    if (data.browserTitle) {
      this.titleService.setTitle(data.browserTitle);
    } else {
      this.titleService.setTitle('营销收费系统');
    }
    if (data.loginIconPath) {
      if (data.loginIconSource === 1) {
        this.handleDownloadLocalIcon(data, 'login');
      } else if (data.loginIconSource === 2) {
        this.handleDownloadCOSIcon(data, 'login');
      }
    } else {
      this.messagesService.sendMessage({
        name: this.messageType.REFRESH_LOGIN_TITLE,
        isShowCopyright: data.isShowCopyright,
        loginTitle: data.loginTitle,
        loginPic: null,
      });
    }
    if (data.menuExpandIconPath) {
      if (data.menuExpandIconSource === 1) {
        this.handleDownloadLocalIcon(data, 'menuExpand');
      } else if (data.menuExpandIconSource === 2) {
        this.handleDownloadCOSIcon(data, 'menuExpand');
      }
    } else {
      this.defaultMenuLogoBig = '../../../assets/images/' + environment.loginLogo;
    }
    if (data.menuFoldIconPath) {
      if (data.menuFoldIconSource === 1) {
        this.handleDownloadLocalIcon(data, 'menuFold');
      } else if (data.menuFoldIconSource === 2) {
        this.handleDownloadCOSIcon(data, 'menuFold');
      }
    } else {
      this.defaultMenuLogoSmall = '../../../assets/images/' + environment.loginLogo;
    }
  }

  handleDownloadLocalIcon(data, flag) {
    switch (flag) {
      case 'login':
        if (this.router.url === '/login' || (this.router.url === '/' && !this.hasLoggedIn)) {
          this.downLoadImgUnauthorized(data);
          this.messagesService.sendMessage({
            name: this.messageType.REFRESH_LOGIN_TITLE,
            isShowCopyright: data.isShowCopyright,
            loginTitle: data.loginTitle,
          });
        } else {
          this.getFileDownLoadURL(data.loginIconPath, flag);
        }
        break;
      case 'menuExpand':
        this.getFileDownLoadURL(data.menuExpandIconPath, flag);
        break;
      case 'menuFold':
        this.getFileDownLoadURL(data.menuFoldIconPath, flag);
        break;
    }
  }

  handleDownloadCOSIcon(data, flag) {
    switch (flag) {
      case 'login':
        this.loginCos = new COSFileUpload(
          this.dataService,
          this.config,
          this.httpClient,
          this.sanitizer,
          this.tencentBucket,
          this.tencentAppID,
          this.messagesService
        );
        this.loginCos.initCOS(fileSourceModel.tencentCOS, '');
        this.loginCos.checkCOSFileNotSign(data.loginIconPath, false, data.loginIconName, flag);
        break;
      case 'menuExpand':
        this.menuBigCos = new COSFileUpload(
          this.dataService,
          this.config,
          this.httpClient,
          this.sanitizer,
          this.tencentBucket,
          this.tencentAppID,
          this.messagesService
        );
        this.menuBigCos.initCOS(fileSourceModel.tencentCOS, '');
        this.menuBigCos.checkCOSFileNotSign(
          data.menuExpandIconPath,
          false,
          data.menuExpandIconName,
          'menuBig'
        );
        break;
      case 'menuFold':
        this.menuSmallCos = new COSFileUpload(
          this.dataService,
          this.config,
          this.httpClient,
          this.sanitizer,
          this.tencentBucket,
          this.tencentAppID,
          this.messagesService
        );
        this.menuSmallCos.initCOS(fileSourceModel.tencentCOS, '');
        this.menuSmallCos.checkCOSFileNotSign(
          data.menuFoldIconPath,
          false,
          data.menuFoldIconName,
          'menuSmall'
        );
        break;
    }
  }

  setImageUrl(data) {
    // this.loginCos.fileList = [];
    // this.menuBigCos.fileList = [];
    // this.menuSmallCos.fileList = [];
    if (data.loginIconPath) {
      this.loginCos = new COSFileUpload(
        this.dataService,
        this.config,
        this.httpClient,
        this.sanitizer,
        this.tencentBucket,
        this.tencentAppID,
        this.messagesService
      );
      this.loginCos.initCOS(fileSourceModel.tencentCOS, '');
      this.loginCos.checkCOSFileNotSign(data.loginIconPath, false, data.loginIconName, 'login');
    } else {
      this.messagesService.sendMessage({ name: this.messageType.REFRESH_LOGIN_PIC, value: null });
    }
    if (data.menuExpandIconPath) {
      this.menuBigCos = new COSFileUpload(
        this.dataService,
        this.config,
        this.httpClient,
        this.sanitizer,
        this.tencentBucket,
        this.tencentAppID,
        this.messagesService
      );
      this.menuBigCos.initCOS(fileSourceModel.tencentCOS, '');
      this.menuBigCos.checkCOSFileNotSign(
        data.menuExpandIconPath,
        false,
        data.menuExpandIconName,
        'menuBig'
      );
    } else {
      localStorage.setItem('menuLogoBig', '');
      this.messagesService.sendMessage({ name: this.messageType.REFRESH_MENU_IMG_BIG });
    }
    if (data.menuFoldIconPath) {
      this.menuSmallCos = new COSFileUpload(
        this.dataService,
        this.config,
        this.httpClient,
        this.sanitizer,
        this.tencentBucket,
        this.tencentAppID,
        this.messagesService
      );
      this.menuSmallCos.initCOS(fileSourceModel.tencentCOS, '');
      this.menuSmallCos.checkCOSFileNotSign(
        data.menuFoldIconPath,
        false,
        data.menuFoldIconName,
        'menuSmall'
      );
    } else {
      localStorage.setItem('menuLogoSmall', '');
      this.messagesService.sendMessage({ name: this.messageType.REFRESH_MENU_IMG_SMALL });
    }
  }

  getFileDownLoadURL(fileId, flag) {
    const url = `${this.uploadUrl}/api/fileManagement/file/${fileId}/downloadInfo`;
    if (fileId) {
      this.httpClient
        .get(url, {
          headers: { Authorization: this.httpHeader },
        })
        .subscribe(
          (data) => {
            // @ts-ignore
            this.downloadImgByPathAPI(fileId, data.token, flag);
          },
          (error) => {
            // console.log('获取文件信息失败：   ' + error);
            switch (flag) {
              case 'login':
                this.messagesService.sendMessage({
                  name: this.messageType.REFRESH_LOGIN_PIC,
                  value: null,
                });
                break;
              case 'menuExpand':
                this.defaultMenuLogoBig = '../../../assets/images/' + environment.loginLogo;
                break;
              case 'menuFold':
                this.defaultMenuLogoSmall = '../../../assets/images/' + environment.loginLogo;
                break;
            }
            // this.message.create('error', `获取图片下载地址失败，${error?.error?.error?.message}`);
          }
        );
    }
  }

  downLoadImgUnauthorized(data) {
    const imgUrl = `${this.uploadUrl}/api/app/files/downloadLoginIcon`;
    if (data.loginIconPath) {
      this.httpClient
        .get(imgUrl, {
          headers: { Authorization: this.httpHeader },
          responseType: 'blob',
          observe: 'response',
          params: { FilePath: data.loginIconPath, TenantId: this.tenantId },
        })
        .subscribe(
          (res) => {
            const blob = new Blob([res.body], { type: res.body?.type });
            const objectURL = URL.createObjectURL(blob);
            const imageUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
            this.messagesService.sendMessage({
              name: this.messageType.REFRESH_LOGIN_PIC,
              // @ts-ignore
              value: imageUrl.changingThisBreaksApplicationSecurity,
            });
          },
          (error) => {
            // console.log('获取文件失败,' + error);
            // this.message.create('error', `获取文件失败，${error?.error?.error?.message}`);
          }
        );
    } else {
      this.messagesService.sendMessage({ name: this.messageType.REFRESH_LOGIN_PIC, value: null });
    }
  }

  downloadImgByPath(data) {
    _.forIn(data, (value, key) => {
      switch (key) {
        case 'loginIconPath':
          if (data.loginIconPath) {
            this.getFileDownLoadURL(value, 'login');
          } else {
            this.messagesService.sendMessage({
              name: this.messageType.REFRESH_LOGIN_PIC,
              value: null,
            });
          }
          break;
        case 'menuExpandIconPath':
          if (data.menuExpandIconPath) {
            this.getFileDownLoadURL(value, 'menuExpand');
          } else {
            this.defaultMenuLogoBig = '../../../assets/images/' + environment.loginLogo;
          }
          break;
        case 'menuFoldIconPath':
          if (data.menuFoldIconPath) {
            this.getFileDownLoadURL(value, 'menuFold');
          } else {
            this.defaultMenuLogoSmall = '../../../assets/images/' + environment.loginLogo;
          }
          break;
      }
    });
  }

  downloadImgByPathAPI(fileId, fileToken, flag) {
    const imgUrl = `${this.uploadUrl}/api/fileManagement/file/${fileId}/download`;
    if (fileId) {
      this.httpClient
        .get(imgUrl, {
          headers: { Authorization: this.httpHeader },
          responseType: 'blob',
          observe: 'response',
          params: { token: fileToken },
        })
        .subscribe(
          (data) => {
            const blob = new Blob([data.body], { type: data.body?.type });
            const objectURL = URL.createObjectURL(blob);
            const imageUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
            switch (flag) {
              case 'login':
                this.messagesService.sendMessage({
                  name: this.messageType.REFRESH_LOGIN_PIC,
                  // @ts-ignore
                  value: imageUrl.changingThisBreaksApplicationSecurity,
                });
                break;
              case 'menuExpand':
                // @ts-ignore
                this.defaultMenuLogoBig = imageUrl.changingThisBreaksApplicationSecurity;
                break;
              case 'menuFold':
                // @ts-ignore
                this.defaultMenuLogoSmall = imageUrl.changingThisBreaksApplicationSecurity;
                break;
            }
            this.isSpinning = false;
          },
          (error) => {
            // this.message.create('error', `下载图片文件失败，${error.error?.error?.message || ''}`);
            // console.log('下载图片文件失败:  ' + error);
            switch (flag) {
              case 'login':
                this.messagesService.sendMessage({
                  name: this.messageType.REFRESH_LOGIN_PIC,
                  value: null,
                });
                break;
              case 'menuExpand':
                this.defaultMenuLogoBig = '../../../assets/images/' + environment.loginLogo;
                break;
              case 'menuFold':
                this.defaultMenuLogoSmall = '../../../assets/images/' + environment.loginLogo;
                break;
            }
            // this.defaultMenuLogoBig = '../assets/images/index/menu-logo.png';
            // this.defaultMenuLogoSmall = '../assets/images/index/menu-logo-small.png';
            // this.messagesService.sendMessage({name: this.messageType.REFRESH_LOGIN_PIC, value: null});
          }
        );
    }
  }

  getTenantId() {
    if (this.embedMode) {
      this.isSpinning = false;
      return;
    }

    this.isSpinning = true;
    this.setHeader();
    const hostName = window.location.host.split('.')[0];
    if (hostName === 'www') {
      this.getPageSettingData('');
    } else {
      this.accountService.findTenant(hostName).subscribe(
        (data) => {
          this.tenantId = data.tenantId;
          localStorage.setItem('tenantName', data.name);
          this.getPageSettingData(data.tenantId);
        },
        (error) => {
          this.message.create('error', dealError('获取租户ID', error));
        }
      );
    }
  }

  logout() {
    this.isSpinning = true;
    localStorage.removeItem('localReadingDate');
    this.dataService.logoutFor3H().subscribe(
      (data) => {
        this.logoutFun();
      },
      (error) => {
        this.logoutFun();
        this.message.create('error', dealError(`logout`, error));
      }
    );
  }

  logoutFun() {
    this.authService.logout().subscribe(() => {
      this.isSpinning = false;
      this.loginUserName = null;
      for (const item of this.tabArray) {
        SimpleReuseStrategy.deleteRouteSnapshot(item.path, item.component);
      }
      // sessionStorage.removeItem('loginUserName');
      localStorage.setItem('menus', null);
      this.menuArray = [];
      this.store.dispatch(new SetTenant(null));
      this.tabArray.splice(1, this.tabArray.length - 1);
      localStorage.setItem('tabArrString', JSON.stringify(this.tabArray));
      localStorage.setItem('initMenuIsCollapsed', '1');
      this.router.navigate(['/login']);
      this.embeddedSessionBootstrapStarted = false;
      this.embeddedLoginInitialized = false;
      this.getTenantId();
    });
  }

  getUserSystemInfo() {
    const userConfig = this.config.getAll();
    this.rolesList = this.config.getAll()?.currentUser?.roles as any[];
    if (userConfig.currentUser.tenantId) {
      this.dataService.getSystemInfo().subscribe(
        (data) => {
          // if (!data.changedPassword) {
          //   this.message.warning('您还没有修改过密码，请前往修改', { nzDuration: 5000 });
          // }
          if (data.changedPassword) {
            this.isShowModal = true;
          }
          if (data.restDays <= 10) {
            this.message.warning(`您的授权将在${data.restDays}天后到期，请您及时续费！`, {
              nzDuration: 5000,
            });
          }
          if (data.messageType) {
            switch (data.messageType) {
              case 'LICENSE_LEGAL_TYPE':
                this.notificationService.error('系统通知', data.msg || '', { nzDuration: 0 });
                break;
              case 'LICENSE_TYPE':
                this.notificationService.warning('系统通知', data.msg || '', { nzDuration: 0 });
            }
          }
        },
        (error) => {
          this.isSpinning = false;
        }
      );
    }
  }

  closeTab(tab): void {
    if (tab.name === '首页') {
      return;
    }
    if (tab.name === '抄表录入') {
      const data = JSON.parse(localStorage.getItem('localReadingDate'));
      if (data && data.length) {
        this.modal.confirm({
          nzContent: `<i nz-icon nzType='exclamation-circle' nzTheme='outline'></i>    当前页面有未保存的数据，是否放弃更改！`,
          nzOkText: '是',
          nzOkType: 'primary',
          nzOnOk: () => {
            localStorage.removeItem('localReadingDate');
            this.closeTabFun(tab);
          },
          nzCancelText: '否',
        });
        return;
      } else {
        this.closeTabFun(tab);
      }
    } else if (tab.name === '册本调整') {
      if (localStorage.getItem('bookAdjustmentData')) {
        this.modal.confirm({
          nzContent: `<i nz-icon nzType='exclamation-circle' nzTheme='outline'></i>    当前页面有未保存的数据，是否放弃更改！`,
          nzOkText: '是',
          nzOkType: 'primary',
          nzOnOk: () => {
            localStorage.removeItem('bookAdjustmentData');
            this.closeTabFun(tab);
          },
          nzCancelText: '否',
        });
        return;
      } else {
        this.closeTabFun(tab);
      }
    } else {
      this.closeTabFun(tab);
    }
    // if (this.tabArray.length === 0) {
    //   this.router.navigate(['/basic_form/basic_form'], { state: { redirectUrl: this.router.url } });
    //   this.newTab(_.find(this.pathArray, obj => obj.path === '/basic_form/basic_form'));
    // } else if (index === this.tabArray.length) {
    //   this.router.navigate([this.tabArray[index].path], { state: { redirectUrl: this.router.url } });
    // }
  }

  closeTabFun(tab) {
    const index = this.tabArray.indexOf(tab);
    if (this.tabArray.length > 1) {
      SimpleReuseStrategy.deleteRouteSnapshot(
        this.tabArray[index].path,
        this.tabArray[index].component
      );
      this.tabArray.splice(index, 1);
      localStorage.setItem('tabArrString', JSON.stringify(this.tabArray));
      if (index === this.tabArray.length) {
        this.router.navigate([this.tabArray[index - 1].path], {
          state: { redirectUrl: this.router.url },
        });
      } else {
        this.router.navigate([this.tabArray[index].path], {
          state: { redirectUrl: this.router.url },
        });
      }
    }
  }

  newTab(obj): void {
    if (obj) {
      if (this.tabArray.length === 0) {
        this.tabArray.push(obj);
      }
      if (this.tabArray.length === 1 && obj.name === '首页') {
        this.tabArray.splice(0, 1, obj);
      } else {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.tabArray.length; i++) {
          this.tabArray[i].active = false;
        }
        const index = _.findIndex(this.tabArray, (item) => item.name === obj.name);
        obj.active = true;
        if (index > -1) {
          this.tabArray.splice(index, 1, obj);
        } else {
          this.tabArray.push(obj);
        }
      }
      this.tabArray = _.uniqBy(this.tabArray, 'name');
    }
  }

  tabClick(data, index) {
    data.active = true;
    // let tabClass = '';
    // if (index > 0){
    //   tabClass = 'tab' + (index - 1);
    //   // @ts-ignore
    //   document.getElementsByClassName(tabClass)[0].style.borderRight = 'none';
    // }
    this.tabArray.forEach((item, i) => {
      if (i !== index) {
        item.active = false;
      }
    });
  }

  refresh() {
    clearInterval(this.timer);
    clearInterval(this.infoTimer);
    this.messagesService.sendMessage({
      path: this.router.url,
      name: this.messageType.REFRESH_CURRENT_COMP,
    });
    // this.getCustomerFile();
    // this.infoTimer = setInterval(() => {
    //   this.getCustomerFile();
    // }, 300000);
    if (this.isOpenTaskNotice === '1') {
      this.getTodo();
      this.loadPopupAnnouncements();
      this.timer = setInterval(() => {
        this.getTodo();
        this.loadPopupAnnouncements();
      }, 300000);
    }
  }

  onCustomerSelected(customer: any) {
    // 处理客户选择事件
    this.router.navigate(['/customer_info/customer_detail']);
    this.messagesService.sendMessage({
      name: this.messageType.SHOW_CUSTOMER_DETAIL,
      value: customer,
    });
    localStorage.removeItem('currentCust');
  }

  rightClickFun(e, tab, i) {
    e.preventDefault();
    // if(tab.name !=='首页'){
    this.isShowRightClickPlane = true;
    this.currentTab = tab;
    this.currentTabIndex = i;
    if (document.getElementsByClassName('ant-tabs-nav-container-scrolling').length) {
      if (i === 0) {
        document.getElementById('rightClickPlane').style.left = 88 + 'px';
      } else {
        if (this.isCollapsed) {
          document.getElementById('rightClickPlane').style.left = e.clientX - e.offsetX + 12 + 'px';
        } else {
          // 左侧栏展开时要重新计算
          document.getElementById('rightClickPlane').style.left =
            e.clientX - e.offsetX - 100 + 12 + 'px';
        }
        //   document.getElementById('rightClickPlane').style.left = i * 110 + 83 + 'px';
      }
    } else {
      if (i === 0) {
        document.getElementById('rightClickPlane').style.left = '80px';
      } else {
        document.getElementById('rightClickPlane').style.left = i * 110 + 72 + 'px';
      }
    }

    // }
  }

  closeTabs(flag, e) {
    // e.stopPropagation();
    const leftEnd = this.currentTabIndex - 1;
    const rightStart = this.currentTabIndex + 1;
    const length = this.tabArray.length;
    switch (flag) {
      // 关闭其他标签
      case 1:
        switch (this.currentTabIndex) {
          case 0:
            this.tabArray.splice(rightStart);
            this.tabRedirect(0);
            break;
          case 1:
            this.tabArray.splice(rightStart);
            this.tabRedirect(1);
            break;
          case length - 1:
            this.tabArray.splice(1, leftEnd);
            this.tabRedirect(1);
            break;
          default:
            this.tabArray.splice(1, leftEnd);
            this.tabArray.splice(2);
            this.tabRedirect(1);
            break;
        }
        for (const item of this.tabArray) {
          SimpleReuseStrategy.deleteRouteSnapshot(item.path, item.component);
        }
        break;

      //  flag=2 关闭全部标签
      case 2:
        for (const item of this.tabArray) {
          SimpleReuseStrategy.deleteRouteSnapshot(item.path, item.component);
        }
        this.tabArray.splice(1);
        this.tabRedirect(0);
        break;

      // flag=3 关闭左侧标签
      case 3:
        switch (this.currentTabIndex) {
          case 0:
          case 1:
            break;
          case length - 1:
            for (let i = 1; i < length - 1; i++) {
              SimpleReuseStrategy.deleteRouteSnapshot(
                this.tabArray[i].path,
                this.tabArray[i].component
              );
            }
            this.tabArray.splice(1, length - 2);
            this.tabRedirect(1);
            break;
          default:
            for (let i = 1; i < leftEnd; i++) {
              SimpleReuseStrategy.deleteRouteSnapshot(
                this.tabArray[i].path,
                this.tabArray[i].component
              );
            }
            this.tabArray.splice(1, leftEnd);
            const activeTabIndex = _.findIndex(this.tabArray, ['active', true]);
            if (activeTabIndex === -1) {
              this.tabRedirect(1);
            }
            break;
        }
        break;

      // flag=4 关闭右侧标签
      case 4:
        switch (this.currentTabIndex) {
          case 0:
            for (let i = rightStart; i < length - 1; i++) {
              SimpleReuseStrategy.deleteRouteSnapshot(
                this.tabArray[i].path,
                this.tabArray[i].component
              );
            }
            this.tabArray.splice(rightStart);
            this.tabRedirect(0);
            break;
          case 1:
            for (let i = rightStart; i < length - 1; i++) {
              SimpleReuseStrategy.deleteRouteSnapshot(
                this.tabArray[i].path,
                this.tabArray[i].component
              );
            }
            this.tabArray.splice(rightStart);
            this.tabRedirect(1);
            break;
          case length - 1:
            break;
          default:
            for (let i = rightStart; i < length - 1; i++) {
              SimpleReuseStrategy.deleteRouteSnapshot(
                this.tabArray[i].path,
                this.tabArray[i].component
              );
            }
            this.tabArray.splice(rightStart);
            const activeTabIndex = _.findIndex(this.tabArray, ['active', true]);
            if (activeTabIndex === -1) {
              this.tabRedirect(this.currentTabIndex);
            }
            break;
        }
        break;
    }
    // this.isShowRightClickPlane = false;
    localStorage.setItem('tabArrString', JSON.stringify(this.tabArray));
  }

  tabRedirect(i) {
    if (!this.tabArray[i].active) {
      this.router.navigate([this.tabArray[i].path], { state: { redirectUrl: this.router.url } });
      this.tabArray[i].active = true;
    }
  }

  getSystemSetting() {
    const codes = ['IS_OPEN_TASK_NOTICE', 'CUSTINFOS_NEED_DESENSITIZATION', 'IS_OPEN_DEPOSIT'];
    this.dataService.getSettingsByCodes(codes.join(',')).subscribe(
      (data) => {
        this.isOpenTaskNotice = data?.IS_OPEN_TASK_NOTICE?.settingValue;
        if (this.isOpenTaskNotice === '1') {
          this.getTodo();
          this.loadPopupAnnouncements();
          this.timer = setInterval(() => {
            this.getTodo();
            this.loadPopupAnnouncements();
          }, 300000);
        }
        if (data?.CUSTINFOS_NEED_DESENSITIZATION?.settingValue) {
          this.showDataMaskingBtn = data?.CUSTINFOS_NEED_DESENSITIZATION?.settingValue === '1';
          sessionStorage.setItem('dataMasking', data?.CUSTINFOS_NEED_DESENSITIZATION.settingValue);
          this.messagesService.sendMessage({
            name: this.messageType.CHANGE_DATA_MASKING,
            value: data?.CUSTINFOS_NEED_DESENSITIZATION?.settingValue === '1',
          });
        }
        if (data?.IS_OPEN_DEPOSIT) {
          sessionStorage.setItem('isOpenDeposit', data?.IS_OPEN_DEPOSIT.settingValue);
        }
      },
      (error) => {
        this.message.create('error', dealError(`获取系统参数`, error));
      }
    );
  }

  getUserTitle() {
    this.dataService.getUserTitle().subscribe(
      (data) => {
        this.loginUserName = data.name;
        sessionStorage.setItem('loginUserName', this.loginUserName);
        sessionStorage.setItem('loginTenantName', data.tenantFullName);
      },
      (error) => {
        this.message.create('error', dealError(`获取租户名称`, error));
      }
    );
  }

  showFullScreen() {
    const element = document.getElementById('container-body');
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      this.requestFullScreen(element);
    }
  }

  requestFullScreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }

  showTodoList(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.isOpenTaskNotice !== '1') {
      this.isShowInfoList = false;
      return;
    }
    this.isShowTodoList = !this.isShowTodoList;
    if (this.isShowTodoList) {
      this.isShowInfoList = false;
    }
  }
  returnToEdit(data) {
    const datas = {
      id: data.custId,
      custCode: data.custCode,
      custName: data.custName,
      taskType: data.taskType,
      taskID: data.taskID,
      workFlowState: data.workFlowState,
      sfth: data.sfth,
    };
    if (data.businessType === 1) {
      this.router.navigate(['/customer_info/customer_detail']);
      localStorage.removeItem('currentCust');
      this.messagesService.sendMessage({
        name: this.messageType.SHOW_CUSTOMER_DETAIL,
        value: datas,
      });
    } else {
      if (data.taskType === 1) {
        // 预存调整
        this.router.navigate(['/accadjust/account_record']);
        this.messagesService.sendMessage({
          name: this.messageType.NORECONCILE_WORKFLOOR_OPEN,
          value: datas,
        });
      } else if (data.taskType === 6) {
        // 已销调整
        this.router.navigate(['/accadjust/payadjust']);
        this.messagesService.sendMessage({
          name: this.messageType.NORECONCILE_WORKFLOOR_OPEN,
          value: datas,
        });
      } else {
        // 未销调整
        this.router.navigate(['/accadjust/nopay']);
        this.messagesService.sendMessage({
          name: this.messageType.NORECONCILE_WORKFLOOR_OPEN,
          value: datas,
        });
      }
    }
  }

  toRefuseData(data) {
    // 审批不通过的数据，点击一次后列表不再显示
    // this.dataService.upDataWorkflowState(data.id).subscribe(
    this.dataService.upDataTodoList(data.taskID).subscribe(
      () => {
        window.open(data.formUrl);
        this.getTodo();
        // window.open(data.url);
        // this.getCustomerFile();
      },
      (error) => {
        this.message.create('error', dealError(`更新工单状态`, error));
      }
    );
  }

  showInfoList(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isShowInfoList = !this.isShowInfoList;
    if (this.isShowInfoList) {
      this.isShowTodoList = false;
    }
  }
  downLoadExcel(item) {
    // this.message.remove();
    // sessionStorage.setItem('loadingMessageId', this.message.loading(`导出数据中...99.71%`, {nzDuration: 0, nzAnimate: false}).messageId);
    this.downloadPercent = 99.09;
    const accessToken = localStorage.getItem('access_token');
    const headers = new HttpHeaders().set(
      'Authorization',
      (accessToken && `Bearer ${accessToken}`) || ''
    );
    // const url = `${this.apiUrl}/api/app/exportJob/${item.id}/downloadFile`;
    // const accessToken = localStorage.getItem('access_token');
    // const httpHeader = 'Bearer ' + accessToken;
    // const id = this.message.loading('导出数据中...', {nzDuration: 0}).messageId;
    this.dataService
      .systemDownloadFile(item.id, headers, { responseType: 'blob', observe: 'response' })
      .subscribe(
        (data) => {
          // @ts-ignore
          const blob = new Blob([data.body], { type: 'application/xlsx' });
          // @ts-ignore
          const name = data.headers.get('Content-Disposition').split("''")[1];
          fs.saveAs(blob, decodeURIComponent(name.split('.')[0]) + '.' + name.split('.')[1]);
          // const id = sessionStorage.getItem('loadingMessageId');
          // if (id) {
          //   this.message.remove(id);
          // }
          this.notificationService.remove();
          // this.getCustomerFile();
        },
        (error) => {
          this.message.create('error', dealError('下载', error));
          // const id = sessionStorage.getItem('loadingMessageId');
          // if (id) {
          //   this.message.remove(id);
          // }
          this.notificationService.remove();
        }
      );
    // this.httpClient.post(url, {id: item.id}, {
    //   headers: {Authorization: httpHeader},
    //   responseType: 'blob',
    //   observe: 'response',
    // }).subscribe(data => {
    //     const blob = new Blob([data.body], {type: 'application/xlsx'});
    //     const name = data.headers.get('Content-Disposition').split('\'\'')[1];
    //     fs.saveAs(blob, decodeURIComponent(name.split('.')[0]) + '.' + name.split('.')[1]);
    //     // const id = sessionStorage.getItem('loadingMessageId');
    //     // if (id) {
    //     //   this.message.remove(id);
    //     // }
    //     this.notificationService.remove();
    //     this.getCustomerFile();
    //   },
    //   (error) => {
    //     this.message.create('error', dealError('下载', error));
    //     // const id = sessionStorage.getItem('loadingMessageId');
    //     // if (id) {
    //     //   this.message.remove(id);
    //     // }
    //     this.notificationService.remove();
    //   });
  }
  clearCache() {
    this.modal.confirm({
      nzContent: `<i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>    确认清除系统缓存数据？`,
      nzOkText: '是',
      nzOkType: 'primary',
      nzOnOk: () => {
        this.isSpinning = true;
        this.dataService.clearCache().subscribe(
          () => {
            this.isSpinning = false;
            this.message.success('清除缓存成功');
          },
          (error) => {
            this.isSpinning = false;
            this.message.create('error', dealError(`清除缓存`, error));
          }
        );
      },
      nzCancelText: '否',
      nzOnCancel: () => {},
    });
  }

  /**
   * 初始化全局剪贴板自动trim功能
   * 处理复制和粘贴事件，自动清除首尾空格
   */
  initGlobalClipboardTrim() {
    // 全局复制事件监听 - 在复制时就trim内容
    document.addEventListener('copy', (event: ClipboardEvent) => {
      if (this.shouldSkipTrim(event.target as HTMLElement)) {
        return;
      }

      const selection = window.getSelection();
      if (selection && selection.toString()) {
        const trimmedText = selection.toString().trim();
        // 如果trim后的内容与原内容不同，则修改剪贴板内容
        if (trimmedText !== selection.toString()) {
          event.preventDefault();
          event.clipboardData?.setData('text/plain', trimmedText);
        }
      }
    });

    // 全局粘贴事件监听 - 在粘贴时trim内容（双重保障）
    document.addEventListener('paste', (event: ClipboardEvent) => {
      const target = event.target as HTMLElement;

      if (this.shouldSkipTrim(target)) {
        return;
      }

      // 只处理输入框和可编辑元素
      if (this.isEditableElement(target)) {
        const pasteData = event.clipboardData?.getData('text/plain');
        if (pasteData) {
          const trimmedData = pasteData.trim();
          // 如果trim后内容发生变化，则阻止默认行为并手动插入trim后的内容
          if (trimmedData !== pasteData) {
            event.preventDefault();
            this.insertTextAtCursor(target, trimmedData);
          }
        }
      }
    });
  }

  /**
   * 判断是否应该跳过trim处理
   * @param element 目标元素
   */
  private shouldSkipTrim(element: HTMLElement): boolean {
    if (!element) {
      return true;
    }

    // 检查元素或其父元素是否有排除标记
    let currentElement: HTMLElement | null = element;
    while (currentElement) {
      // 通过data属性排除
      if (currentElement.hasAttribute('data-preserve-whitespace')) {
        return true;
      }
      // 通过CSS类排除
      if (
        currentElement.classList.contains('no-trim') ||
        currentElement.classList.contains('preserve-whitespace')
      ) {
        return true;
      }
      // 排除富文本编辑器
      if (
        currentElement.classList.contains('ql-editor') ||
        currentElement.classList.contains('w-e-text') ||
        currentElement.classList.contains('tox-edit-area')
      ) {
        return true;
      }
      // 排除代码编辑器
      if (
        currentElement.tagName === 'PRE' ||
        currentElement.tagName === 'CODE' ||
        currentElement.classList.contains('CodeMirror')
      ) {
        return true;
      }
      currentElement = currentElement.parentElement;
    }
    return false;
  }

  /**
   * 判断元素是否可编辑
   * @param element 目标元素
   */
  private isEditableElement(element: HTMLElement): boolean {
    const tagName = element.tagName.toLowerCase();
    // 输入框和文本域
    if (tagName === 'input' || tagName === 'textarea') {
      return true;
    }
    // contenteditable元素
    if (element.isContentEditable) {
      return true;
    }
    return false;
  }

  /**
   * 在光标位置插入文本
   * @param element 目标元素
   * @param text 要插入的文本
   */
  private insertTextAtCursor(element: HTMLElement, text: string) {
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
      const input = element as HTMLInputElement | HTMLTextAreaElement;
      const startPos = input.selectionStart || 0;
      const endPos = input.selectionEnd || 0;
      const currentValue = input.value;

      // 在光标位置插入文本
      input.value = currentValue.substring(0, startPos) + text + currentValue.substring(endPos);

      // 设置光标位置到插入文本之后
      const newPos = startPos + text.length;
      input.setSelectionRange(newPos, newPos);

      // 触发input事件，确保Angular表单检测到变化
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (element.isContentEditable) {
      // 处理contenteditable元素
      document.execCommand('insertText', false, text);
    }
  }

  // ==================== 侧边栏相关方法 ====================

  /**
   * 切换侧边栏折叠/展开状态
   * 在用户点击折叠按钮时调用
   */
  trigger() {
    this.isCollapsed = !this.isCollapsed;
    this.initMenuIsCollapsed = !this.initMenuIsCollapsed;

    // 更新主内容区域和页脚的宽度
    this.triggerWidth(this.isCollapsed);

    // 保存折叠状态到 localStorage
    localStorage.setItem('initMenuIsCollapsed', this.initMenuIsCollapsed ? '1' : '0');
  }

  /**
   * 根据侧边栏状态动态调整主内容区域和页脚的宽度
   * @param collapsedState 可选参数，明确指定折叠状态；不传则使用实例属性
   */
  triggerWidth(collapsedState?: boolean) {
    const isCollapsed = collapsedState !== undefined ? collapsedState : this.isCollapsed;
    const shouldShowSider = this.isShowMenu && !this.hiddenSiderAndHeader;
    const siderWidth = shouldShowSider ? (isCollapsed ? '60px' : '160px') : '0px';

    // 在 :host 元素上设置 CSS 变量，所有子元素会自动继承
    this.el.nativeElement.style.setProperty('--width-sider', siderWidth);

    // 保存状态并发送消息通知其他组件
    localStorage.setItem('widthSider', siderWidth);
    this.messagesService.sendMessage({ name: this.messageType.IS_COLLAPSED, value: siderWidth });
  }

  /**
   * 初始化侧边栏状态
   * 从 localStorage 恢复上次保存的折叠/展开状态
   */
  initTrigger() {
    const savedState = localStorage.getItem('initMenuIsCollapsed');

    // 根据保存的状态设置初始值，默认为展开（false）
    if (savedState === '0') {
      // 折叠状态
      this.isCollapsed = true;
      this.initMenuIsCollapsed = false;
    } else {
      // 展开状态（包括 savedState === '1' 或不存在的情况）
      this.isCollapsed = false;
      this.initMenuIsCollapsed = true;
    }

    // 应用侧边栏宽度（会自动发送消息和保存状态）
    this.triggerWidth(this.isCollapsed);
  }
}
